import React, { Component } from 'react'
import Calendar from 'rc-calendar'
import { withStyles, Tooltip, Typography } from '@material-ui/core/'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import Cookies from 'js-cookie'

import moment from 'moment'
import 'moment/locale/en-gb'

import '../../assets/calendar.css'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

// set sunday as first day of the week
moment.updateLocale('en', {
  week: {
    dow: 0,
  }
})

const format = 'YYYY-MM-DD'
const today = moment()

const styles = theme => ({
  root: {
    // margin: '-2em'
  },
  arrow: {
    fontSize: '10px'
  },
  tooltip: {
    fontSize: '14px',
    fontWeight: 'bold',
  }
})

class HomeCalendar extends Component {
  _isMounted = false

  constructor(props) {
    super(props)

    this.state = {
      value: today,
      calData: [],
      darkMode: props.darkMode
    }
  }

  onChange = (value) => {
    this.setState({
      value,
    })
    Promise.all([
      fetch(`${base_url}/calendar?yearmo=${value.format('YYYY-MM')}`, {
        method: 'GET',
        headers: {
          'token': Cookies.get('token')
        },
      }),
      fetch(`${base_url}/calendar?yearmo=${this.state.value.subtract(1, 'months').format('YYYY-MM')}`, {
        method: 'GET',
        headers: {
          'token': Cookies.get('token')
        },
      })
    ])
    .then(([response, response2]) => Promise.all([response.json(), response2.json()]))
    .then(([data, data2]) => {
      this.setState({
        calData: data,
      })
    })
    .catch(error => {
      console.log(error)
    })
  }

  componentDidMount = () => {
    this._isMounted = true    

    fetch(`${base_url}/calendar?yearmo=${this.state.value.format('YYYY-MM')}`, {
      method: 'GET',
      headers: {
        'token': Cookies.get('token')
      },
    })
    .then(response => response.json())
    .then(data => {
      if(this._isMounted) {
        this.setState({
          calData: data,
        })
      }
    })
    .catch(error => {
      console.log(error)
    })
  }

  componentWillUnmount = () => {
    this._isMounted = false
  }

  render() {
    const state = this.state
    const { classes } = this.props

    return(
      <Calendar
        showDateInput={false}
        dateRender={(current) =>
          {
            for(let i = 0; i < this.state.calData.length; i++) {
              if(current.format('YYYY-MM-DD') === this.state.calData[i].Written_Date && this.state.calData[i].Data[0].Sales_YOY_Flag === 1) {
                return (
                  <Tooltip
                    title={
                      <Typography className={classes.tooltip}><span style={{color: '#57ff8a'}}>${Math.round(this.state.calData[i].Data[0].Sales).toLocaleString('en')}</span> in sales this year has yielded a <span style={{color: '#57ff8a'}}>{Math.round(this.state.calData[i].Data[0].Sales_YOY * 100)}% increase</span> from ${Math.round(this.state.calData[i].Data[0].Sales_LY).toLocaleString('en')} in sales from the previous year.</Typography>
                    }
                    style={{zIndex: 10000}}
                  >
                    <div className={`rc-calendar-date ${state.darkMode ? "up" : "up-lt"}`}>{current.format('D')}<ArrowUpwardIcon className={classes.arrow} /></div>
                  </Tooltip>
                )
              }
            }
            for(let j = 0; j < this.state.calData.length; j++) {
              if(current.format('YYYY-MM-DD') === this.state.calData[j].Written_Date && this.state.calData[j].Data[0].Sales_YOY_Flag === -1) {
                return (
                  <Tooltip
                    title={
                      <Typography className={classes.tooltip}><span style={{color: '#ff7d7d'}}>${Math.round(this.state.calData[j].Data[0].Sales).toLocaleString('en')}</span> in sales this year has yielded a <span style={{color: '#ff7d7d'}}>{Math.round(this.state.calData[j].Data[0].Sales_YOY * 100)}% decrease</span> from ${Math.round(this.state.calData[j].Data[0].Sales_LY).toLocaleString('en')} in sales from the previous year.</Typography>
                    }
                    style={{zIndex: 10000}}
                  >
                    <div className={`rc-calendar-date ${state.darkMode ? "down" : "down-lt"}`}>{current.format('D')}<ArrowDownwardIcon className={classes.arrow} /></div>
                  </Tooltip>
                )
              }
            }
            return <div className={`${state.darkMode ? "rc-calendar-date" : "rc-calendar-date-lt"}`}>{current.format('D')}</div>
          }
        }
        format={format}
        value={state.value}
        onChange={this.onChange}
        focusablePanel={false}
        className='rc-calendar-home'
        style={this.props.darkMode ?
          {backgroundColor: 'transparent', marginTop: 12}
        :
          {marginTop: 12}
        }
      />
    )
  }
}

export default withStyles(styles)(HomeCalendar)
